import { mapAriJobToJobCardProps } from './mapAriJobToJobCardProps';
import { calendarDaysAgoLabel } from 'helpers/postedAgo';

/** Where an external job was found, from GET /external-jobs `feed`. */
export const EXTERNAL_SOURCE_LABELS = {
  ats: 'via company careers page',
  jb: 'via job board',
};

/**
 * Map an external job from GET /external-jobs into JobCard view props for
 * the /jobs timeline: "External" with its source, and "View on site".
 *
 * @param {Object} job
 * @returns {Object}
 */
export function mapBoardExternalJobToJobCardProps(job) {
  const props = mapAriJobToJobCardProps(job);
  const postedLabel = calendarDaysAgoLabel(job.postedAt);

  return {
    ...props,
    boardLabel: 'External',
    timeLine: EXTERNAL_SOURCE_LABELS[job.feed] || '',
    footerMeta: postedLabel ? `Posted ${postedLabel}` : '',
    cta: { ...props.cta, label: 'View on site' },
    saveEntryPoint: 'job_listing',
  };
}

export default mapBoardExternalJobToJobCardProps;
